import { mapActions } from 'vuex';
const fireSelected_mixins = {       
  methods: {
    ...mapActions('fireSelected_store', ['ACT_fireSelected']),
    MIX_fireSelected (payload){
      this.ACT_fireSelected(payload);
    },
    
  }
}
export default {
  install (Vue, options) {
    Vue.mixin(fireSelected_mixins)
  }
};  
  